// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n6nQyfHmOucl1B6gByyf .GzlSxm0doJlQWCoaIS8Q {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.n6nQyfHmOucl1B6gByyf .DrZADIZWweDxqQOc4StK {
  position: relative;
  margin-bottom: 5px;
}
.n6nQyfHmOucl1B6gByyf .DrZADIZWweDxqQOc4StK input {
  color: #687E97;
  background-color: var(--surface-color);
  font-size: 16px;
  border-color: #EBEEF2;
  border-radius: 8px;
  padding: 4px 24px 4px 8px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.0627);
  font-family: "Rubik";
}
.n6nQyfHmOucl1B6gByyf .DrZADIZWweDxqQOc4StK input:focus {
  border-color: var(--accent-color);
  box-shadow: none;
}
.n6nQyfHmOucl1B6gByyf .DrZADIZWweDxqQOc4StK input::placeholder {
  color: #687E97;
}
.n6nQyfHmOucl1B6gByyf .DrZADIZWweDxqQOc4StK svg {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  fill: #687E97;
  width: 16px;
  height: 16px;
}
.n6nQyfHmOucl1B6gByyf .Cg6VPJbtArqXaCBtRriu {
  max-height: 280px;
  overflow-y: auto;
  padding-left: 6px;
  margin-left: -6px;
  /* Custom scrollbar */
}
.n6nQyfHmOucl1B6gByyf .Cg6VPJbtArqXaCBtRriu::-webkit-scrollbar {
  width: 6px;
}
.n6nQyfHmOucl1B6gByyf .Cg6VPJbtArqXaCBtRriu::-webkit-scrollbar-track {
  background: color-mix(in srgb, var(--scrollbar-color), transparent 95%);
  border-radius: 10px;
}
.n6nQyfHmOucl1B6gByyf .Cg6VPJbtArqXaCBtRriu::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--scrollbar-color), transparent 30%);
  border-radius: 10px;
}
.n6nQyfHmOucl1B6gByyf .Cg6VPJbtArqXaCBtRriu::-webkit-scrollbar-thumb:hover {
  background: color-mix(in srgb, var(--scrollbar-color), transparent 0%);
}
.n6nQyfHmOucl1B6gByyf .Vvc37nBkm5oxX_0iaqvM {
  margin-bottom: 8px;
  padding-right: 5px;
  padding-left: 5px;
}
.n6nQyfHmOucl1B6gByyf .Vvc37nBkm5oxX_0iaqvM:last-child {
  margin-bottom: 0;
}
.n6nQyfHmOucl1B6gByyf .Vvc37nBkm5oxX_0iaqvM .SXTjAfZMskH_omFzcfvJ {
  display: flex;
  align-items: center;
  margin: 0;
  margin-left: 3px;
}
.n6nQyfHmOucl1B6gByyf .Vvc37nBkm5oxX_0iaqvM .wLqubziKYYPQtrRNddV8 {
  position: relative;
}
.n6nQyfHmOucl1B6gByyf .Vvc37nBkm5oxX_0iaqvM .wLqubziKYYPQtrRNddV8 .RGqA8m7TSplclZDAiTV9 {
  margin-right: 0;
  cursor: pointer;
  width: 20px;
  height: 20px;
  appearance: none;
  -webkit-appearance: none;
  border-radius: 5px;
  border: 1px solid rgba(12, 48, 88, 0.7);
  position: relative;
}
.n6nQyfHmOucl1B6gByyf .Vvc37nBkm5oxX_0iaqvM .wLqubziKYYPQtrRNddV8 .RGqA8m7TSplclZDAiTV9:checked {
  border: 1px solid #0079FF;
  box-shadow: none;
  background-color: #0079FF;
}
.n6nQyfHmOucl1B6gByyf .Vvc37nBkm5oxX_0iaqvM .wLqubziKYYPQtrRNddV8 .RGqA8m7TSplclZDAiTV9:checked + .zWaYYbh6jywcu58s9obe svg {
  display: flex;
  opacity: 1;
}
.n6nQyfHmOucl1B6gByyf .Vvc37nBkm5oxX_0iaqvM .wLqubziKYYPQtrRNddV8 .RGqA8m7TSplclZDAiTV9:focus {
  border: 1px solid #0079FF;
  box-shadow: none;
}
.n6nQyfHmOucl1B6gByyf .Vvc37nBkm5oxX_0iaqvM .wLqubziKYYPQtrRNddV8 .zWaYYbh6jywcu58s9obe svg {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  opacity: 0;
  color: white;
  fill: white;
}
.n6nQyfHmOucl1B6gByyf .Vvc37nBkm5oxX_0iaqvM .rgi30ZobRc82tOvsKJlA {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  font-size: 16px;
  color: #0C3058;
  margin-right: 8px;
  margin-bottom: 2px;
}
.n6nQyfHmOucl1B6gByyf .Vvc37nBkm5oxX_0iaqvM .CblTG7yAduWXnonhtzGZ {
  font-size: 16px;
  color: #0C3058;
  margin-left: auto;
  margin-bottom: 2px;
}
.n6nQyfHmOucl1B6gByyf .hhxEHJaAnQD5ulDpfVnL {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 5px 15px 0;
  border-top: #0068F5;
}
.n6nQyfHmOucl1B6gByyf .hhxEHJaAnQD5ulDpfVnL .Hs4qJ4PMjxBP7G4XLxdQ {
  color: #0068F5;
  border-color: #0068F5;
  border-radius: 6px;
  font-size: 12px;
  padding-top: 6px;
  padding-right: 18px;
  padding-bottom: 6px;
  padding-left: 18px;
  border-width: 0.75px;
  font-weight: 500;
  font-family: "Rubik";
}
.n6nQyfHmOucl1B6gByyf .hhxEHJaAnQD5ulDpfVnL .Hs4qJ4PMjxBP7G4XLxdQ:hover {
  background-color: #EBF3FF;
}
.n6nQyfHmOucl1B6gByyf .hhxEHJaAnQD5ulDpfVnL .Hs4qJ4PMjxBP7G4XLxdQ:focus {
  background-color: #ffffff;
  color: #0068F5;
  border-color: #0068F5;
}
.n6nQyfHmOucl1B6gByyf .hhxEHJaAnQD5ulDpfVnL .G62VfFqjFgZfOBqZQyoo {
  color: #0068F5;
  text-decoration: none;
  padding: 0.25rem 0.5rem;
  font-size: 16px;
  font-weight: 500;
  font-family: "Rubik";
}
.n6nQyfHmOucl1B6gByyf .hhxEHJaAnQD5ulDpfVnL .G62VfFqjFgZfOBqZQyoo:hover {
  text-decoration: underline;
}
@media (max-width: 767.98px) {
  .n6nQyfHmOucl1B6gByyf .Cg6VPJbtArqXaCBtRriu {
    max-height: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./GeneralComponents/SearchResults/searchFilters/multiSelectFilter/MultiSelectFilter.module.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAAR;AAGI;EACI,kBAAA;EACA,kBAAA;AADR;AAGQ;EACI,cAAA;EACA,sCAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kDAAA;EACA,oBAAA;AADZ;AAGY;EACI,iCAAA;EACA,gBAAA;AADhB;AAIY;EACI,cAAA;AAFhB;AAMQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AAJZ;AAQI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;AANR;AAOQ;EACI,UAAA;AALZ;AAQQ;EACI,uEAAA;EACA,mBAAA;AANZ;AASQ;EACI,uEAAA;EACA,mBAAA;AAPZ;AASY;EACI,sEAAA;AAPhB;AAYI;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;AAVR;AAYQ;EACI,gBAAA;AAVZ;AAaQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAXZ;AAcQ;EACI,kBAAA;AAZZ;AAcY;EACI,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AAZhB;AAcgB;EACI,yBAAA;EACA,gBAAA;EACA,yBAAA;AAZpB;AAewB;EACI,aAAA;EACA,UAAA;AAb5B;AAkBgB;EACI,yBAAA;EACA,gBAAA;AAhBpB;AAqBgB;EACI,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,oBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAnBpB;AAwBQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAtBZ;AAyBQ;EACI,eAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAvBZ;AA2BI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AAzBR;AA2BQ;EACI,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,oBAAA;AAzBZ;AA2BY;EACI,yBAAA;AAzBhB;AA4BY;EACI,yBAAA;EACA,cAAA;EACA,qBAAA;AA1BhB;AA8BQ;EACI,cAAA;EACA,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AA5BZ;AA8BY;EACI,0BAAA;AA5BhB;AAiCI;EACI;IACI,iBAAA;EA/BV;AACF","sourcesContent":[".multiselect-filter {\r\n    .multiselect-filter-content {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 15px;\r\n    }\r\n\r\n    .multiselect-search {\r\n        position: relative;\r\n        margin-bottom: 5px;\r\n\r\n        input {\r\n            color: #687E97;\r\n            background-color: var(--surface-color);\r\n            font-size: 16px;\r\n            border-color: #EBEEF2;\r\n            border-radius: 8px;\r\n            padding: 4px 24px 4px 8px;\r\n            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.0627);\r\n            font-family: 'Rubik';\r\n\r\n            &:focus {\r\n                border-color: var(--accent-color);\r\n                box-shadow: none\r\n            }\r\n\r\n            &::placeholder {\r\n                color: #687E97;\r\n            }\r\n        }\r\n\r\n        svg {\r\n            position: absolute;\r\n            left: 12px;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n            fill: #687E97;\r\n            width: 16px;\r\n            height: 16px;\r\n        }\r\n    }\r\n\r\n    .multiselect-list {\r\n        max-height: 280px;\r\n        overflow-y: auto;\r\n        padding-left: 6px; // Space for scrollbar\r\n        margin-left: -6px; // Pull scrollbar outside content area\r\n        /* Custom scrollbar */\r\n        &::-webkit-scrollbar {\r\n            width: 6px;\r\n        }\r\n\r\n        &::-webkit-scrollbar-track {\r\n            background: color-mix(in srgb, var(--scrollbar-color), transparent 95%);\r\n            border-radius: 10px;\r\n        }\r\n\r\n        &::-webkit-scrollbar-thumb {\r\n            background: color-mix(in srgb, var(--scrollbar-color), transparent 30%);\r\n            border-radius: 10px;\r\n\r\n            &:hover {\r\n                background: color-mix(in srgb, var(--scrollbar-color), transparent 0%);\r\n            }\r\n        }\r\n    }\r\n\r\n    .multiselect-item {\r\n        margin-bottom: 8px;\r\n        padding-right: 5px;\r\n        padding-left: 5px;\r\n\r\n        &:last-child {\r\n            margin-bottom: 0;\r\n        }\r\n\r\n        .form-check {\r\n            display: flex;\r\n            align-items: center;\r\n            margin: 0;\r\n            margin-left: 3px;\r\n        }\r\n\r\n        .form-check-wrap {\r\n            position: relative;\r\n\r\n            .form-check-input {\r\n                margin-right: 0;\r\n                cursor: pointer;\r\n                width: 20px;\r\n                height: 20px;\r\n                appearance: none;\r\n                -webkit-appearance: none;\r\n                border-radius: 5px;\r\n                border: 1px solid rgba(12, 48, 88, 0.7);\r\n                position: relative;\r\n\r\n                &:checked {\r\n                    border: 1px solid #0079FF;\r\n                    box-shadow: none;\r\n                    background-color: #0079FF;\r\n                    // Target the overlay sibling when input is checked\r\n                    & + .custom-icon-overlay {\r\n                        svg {\r\n                            display: flex;\r\n                            opacity: 1;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                &:focus {\r\n                    border: 1px solid #0079FF;\r\n                    box-shadow: none;\r\n                }\r\n            }\r\n\r\n            .custom-icon-overlay {\r\n                svg {\r\n                    position: absolute;\r\n                    top: 50%;\r\n                    transform: translate(-50%, -50%);\r\n                    pointer-events: none; // Allows clicking the checkbox through the icon\r\n                    opacity: 0; // Hidden until checked\r\n                    color: white;\r\n                    fill: white;\r\n                }\r\n            }\r\n        }\r\n\r\n        .form-check-label {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: space-between;\r\n            width: 100%;\r\n            cursor: pointer;\r\n            font-size: 16px;\r\n            color: #0C3058;\r\n            margin-right: 8px;\r\n            margin-bottom: 2px;\r\n        }\r\n\r\n        .multiselect-count {\r\n            font-size: 16px;\r\n            color: #0C3058;\r\n            margin-left: auto;\r\n            margin-bottom: 2px;\r\n        }\r\n    }\r\n\r\n    .multiselect-actions {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        padding: 5px 5px 15px 0;\r\n        border-top: #0068F5;\r\n\r\n        .btn-outline-primary {\r\n            color: #0068F5;\r\n            border-color: #0068F5;\r\n            border-radius: 6px;\r\n            font-size: 12px;\r\n            padding-top: 6px;\r\n            padding-right: 18px;\r\n            padding-bottom: 6px;\r\n            padding-left: 18px;\r\n            border-width: 0.75px;\r\n            font-weight: 500;\r\n            font-family: 'Rubik';\r\n\r\n            &:hover {\r\n                background-color: #EBF3FF;\r\n            }\r\n\r\n            &:focus {\r\n                background-color: #ffffff;\r\n                color: #0068F5;\r\n                border-color: #0068F5;\r\n            }\r\n        }\r\n\r\n        .btn-link {\r\n            color: #0068F5;\r\n            text-decoration: none;\r\n            padding: 0.25rem 0.5rem;\r\n            font-size: 16px;\r\n            font-weight: 500;\r\n            font-family: 'Rubik';\r\n\r\n            &:hover {\r\n                text-decoration: underline;\r\n            }\r\n        }\r\n    }\r\n\r\n    @media (max-width: 767.98px) {\r\n        .multiselect-list {\r\n            max-height: 200px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiselect-filter": `n6nQyfHmOucl1B6gByyf`,
	"multiselect-filter-content": `GzlSxm0doJlQWCoaIS8Q`,
	"multiselect-search": `DrZADIZWweDxqQOc4StK`,
	"multiselect-list": `Cg6VPJbtArqXaCBtRriu`,
	"multiselect-item": `Vvc37nBkm5oxX_0iaqvM`,
	"form-check": `SXTjAfZMskH_omFzcfvJ`,
	"form-check-wrap": `wLqubziKYYPQtrRNddV8`,
	"form-check-input": `RGqA8m7TSplclZDAiTV9`,
	"custom-icon-overlay": `zWaYYbh6jywcu58s9obe`,
	"form-check-label": `rgi30ZobRc82tOvsKJlA`,
	"multiselect-count": `CblTG7yAduWXnonhtzGZ`,
	"multiselect-actions": `hhxEHJaAnQD5ulDpfVnL`,
	"btn-outline-primary": `Hs4qJ4PMjxBP7G4XLxdQ`,
	"btn-link": `G62VfFqjFgZfOBqZQyoo`
};
export default ___CSS_LOADER_EXPORT___;
